import { Button, Modal, GreyWhite, Flex } from '@sequencehq/core-components'
import Spinner from 'components/Loading'

export const Footer = (props: {
  onContinue: () => void
  onBack: () => void
  destructive?: boolean
  submitButtonText?: string
  disabled?: boolean
  submitting?: boolean
}) => {
  const submitDisabled = props.disabled || props.submitting

  return (
    <Modal.Footer withBorder>
      <Flex justifyContent="flex-end" width="100%" gap="8px">
        <Button
          variant="secondary"
          onClick={props.onBack}
          data-testid="schedule.shortcut.back"
        >
          Back
        </Button>
        <Button
          variant={props.destructive ? 'destructive' : 'primary'}
          onClick={() => !submitDisabled && props.onContinue()}
          disabled={submitDisabled}
          data-testid="schedule.shortcut.continue"
        >
          <Flex gap="8px">
            {props.submitting && (
              <Spinner height="16px" width="16px" color={GreyWhite} />
            )}
            {props.submitButtonText ?? 'Continue'}
          </Flex>
        </Button>
      </Flex>
    </Modal.Footer>
  )
}
